export default __webpack_public_path__ + "/dist/images/cibecco-bg2.svg";